module.exports = __webpack_public_path__ + "static/media/dark-arrow-left.1820060b.svg";